import React from "react";
import Layout from "@/components/Layout";
import { Sparkles, CheckCircle2, Rocket } from "lucide-react";

/**
 * Add new entries at the TOP of this array. Newest first.
 * Each entry:
 * {
 *   version: "1.2",
 *   date: "June 2026",
 *   title: "Short headline",         // optional
 *   tag: "Launch" | "Feature" | "Fix" | "Improvement",   // optional, drives color
 *   summary: "Short intro sentence", // optional
 *   // Either flat list (legacy) …
 *   highlights: ["bullet 1", "bullet 2", ...]
 *   // … or grouped sections (new). If `sections` is present it takes precedence.
 *   sections: [
 *     { kind: "feature" | "improvement" | "fix", title: "…", items: ["…"] },
 *   ],
 * }
 */
const UPDATES = [
  {
    version: "1.6",
    date: "April 2026",
    title: "AI Performance Coach™",
    tag: "Feature",
    summary:
      "Una nuova funzionalità avanzata pensata per i professionisti che vogliono migliorare il proprio metodo di lavoro.",
    sections: [
      {
        kind: "feature",
        title: "AI Performance Coach™ (nuovo)",
        items: [
          "Sistema di intelligenza artificiale che analizza automaticamente il tuo lavoro: numero di analisi effettuate, clienti serviti, frequenza di utilizzo, conversione in trattamenti, andamento generale",
          "Valutazione del metodo professionale con punteggio 0–100",
          "3 osservazioni mirate sul tuo modo di lavorare",
          "3 consigli pratici e concreti per migliorare",
          "L'AI NON suggerisce prodotti e NON forza la vendita: il focus è esclusivamente sul miglioramento del metodo professionale",
          "Funzione disponibile solo nel piano PRO",
        ],
      },
    ],
  },
  {
    version: "1.5",
    date: "April 2026",
    title: "Aggiornamento funzionalità & pagamenti",
    tag: "Feature",
    sections: [
      {
        kind: "feature",
        title: "Dashboard risultati economici",
        items: [
          "Nuova sezione dedicata al parrucchiere nella Dashboard",
          "Mostra il guadagno reale generato dai prodotti venduti",
          "Calcolo basato esclusivamente sui prodotti contrassegnati come venduti nei report",
          "Quattro indicatori: guadagno totale, numero prodotti venduti, media per cliente, guadagno medio per analisi",
          "Filtro temporale: ultimi 7 giorni, ultimi 30 giorni, totale",
        ],
      },
      {
        kind: "feature",
        title: "Pagamenti",
        items: [
          "Attivato il sistema di pagamento con PayPal",
          "Attivato il pagamento tramite carta di credito",
          "Nuovo flusso di acquisto direttamente dalla pagina “Scegli il tuo piano”",
        ],
      },
      {
        kind: "fix",
        title: "Migliorie",
        items: [
          "Correzione di bug minori",
          "Ottimizzazioni generali di stabilità e performance",
        ],
      },
    ],
  },
  {
    version: "1.4",
    date: "April 2026",
    title: "Follow-up intelligente & miglioramenti sistema",
    tag: "Feature",
    sections: [
      {
        kind: "feature",
        title: "Follow-up intelligente (nuovo)",
        items: [
          "Possibilità di eseguire follow-up su analisi precedenti",
          "Confronto automatico tra stato iniziale e attuale",
          "Generazione di valutazione risultati e protocollo aggiornato",
          "Nuove sezioni dedicate: Confronto evoluzione, Spiegazione cliente follow-up, Guida operatore follow-up",
        ],
      },
      {
        kind: "improvement",
        title: "Miglioramento logica follow-up",
        items: [
          "Il follow-up è sempre disponibile (non più bloccato)",
          "Introduzione messaggio di avviso se eseguito prima dei 30 giorni",
          "Maggiore flessibilità operativa per il parrucchiere",
        ],
      },
      {
        kind: "improvement",
        title: "Migliorie AI",
        items: [
          "Ottimizzazione stabilità analisi",
          "Migliore coerenza tra osservazione e interpretazione",
          "Riduzione output incoerenti",
        ],
      },
      {
        kind: "fix",
        title: "Bug fix",
        items: [
          "Correzione problemi minori nella generazione PDF",
          "Miglioramenti performance generazione analisi",
          "Ottimizzazione interfaccia utente",
        ],
      },
    ],
  },
  {
    version: "1.3",
    date: "April 2026",
    title: "AI TricoAcademy™ e nuove indicazioni tricocamera",
    tag: "Feature",
    summary:
      "Questa versione introduce la nuova area formativa e migliora l'esperienza di analisi.",
    sections: [
      {
        kind: "feature",
        title: "Nuove funzionalità",
        items: [
          "Aggiunta AI TricoAcademy™ — sezione formativa con diagnosi base per supportare i parrucchieri nella lettura delle immagini tricologiche",
        ],
      },
      {
        kind: "improvement",
        title: "Miglioramenti",
        items: [
          "Aggiornata la Guida con i requisiti minimi della tricocamera: connessione Wi-Fi, zoom consigliato 50x–200x, qualità immagini ottimizzata per analisi AI",
        ],
      },
      {
        kind: "fix",
        title: "Fix",
        items: [
          "Risolti bug minori e migliorata la stabilità generale dell'app",
        ],
      },
    ],
  },
  {
    version: "1.2",
    date: "April 2026",
    title: "Miglioramenti esperienza e consulenza",
    tag: "Feature",
    highlights: [
      "Spiegazione semplice per il cliente: il report ora include una versione chiara e comprensibile della diagnosi",
      "Guida alla consulenza (solo operatore): supporto pratico su cosa sta succedendo, come spiegarlo, cosa proporre ed errori da evitare",
      "UX: la guida consulenza è accessibile tramite pulsante dedicato, non più visibile direttamente nel report",
      "Nuovo pulsante «Invia su WhatsApp»: condividi rapidamente il PDF del report con il cliente",
    ],
  },
  {
    version: "1.1",
    date: "April 2026",
    title: "Security & Account Improvements",
    tag: "Improvement",
    highlights: [
      "Password reset flow (forgot password with secure token)",
      "One-time secure reset links with expiration",
      "New change password feature inside user profile",
      "Improved authentication stability and error handling",
    ],
  },
  {
    version: "1.0",
    date: "April 2026",
    title: "Launch",
    tag: "Launch",
    highlights: [
      "First release of AI Trico Protocol",
      "AI-powered hair analysis",
      "Custom domain integration",
      "Booking system for professionals",
    ],
  },
];

const TAG_STYLE = {
  Launch:      "bg-[#C5A059]/15 text-[#8A6B2E] border-[#C5A059]/30",
  Feature:     "bg-emerald-50 text-emerald-700 border-emerald-200",
  Fix:         "bg-rose-50 text-rose-700 border-rose-200",
  Improvement: "bg-blue-50 text-blue-700 border-blue-200",
};

function lastUpdatedLabel(items) {
  if (!items.length) return "—";
  return items[0].date;
}

export default function Updates() {
  return (
    <Layout>
      <div className="max-w-3xl mx-auto" data-testid="updates-page">
        {/* Header */}
        <div className="mb-12">
          <p className="text-[10px] tracking-[0.25em] uppercase text-[#C5A059] font-medium mb-3">
            Changelog
          </p>
          <h1 className="font-serif-display text-4xl sm:text-5xl text-[#1A1A1A] leading-tight mb-4">
            Product updates
          </h1>
          <p className="text-base text-[#737373] leading-relaxed max-w-xl">
            Every improvement we ship to AI TricoProtocol, in reverse chronological order.
          </p>

          <div
            className="mt-6 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#FAF6EE] border border-[#E5E5E0] text-xs text-[#737373]"
            data-testid="updates-last-updated"
          >
            <Sparkles className="w-3.5 h-3.5 text-[#C5A059]" />
            Last updated: <span className="text-[#1A1A1A] font-medium">{lastUpdatedLabel(UPDATES)}</span>
          </div>
        </div>

        {/* Timeline */}
        <div className="relative">
          <div
            aria-hidden
            className="absolute left-[11px] top-2 bottom-2 w-px bg-gradient-to-b from-[#C5A059]/40 via-[#E5E5E0] to-transparent hidden sm:block"
          />

          <ol className="space-y-8 sm:space-y-10">
            {UPDATES.map((u, idx) => {
              const tagClass = TAG_STYLE[u.tag] || TAG_STYLE.Improvement;
              return (
                <li
                  key={`${u.version}-${idx}`}
                  className="relative sm:pl-10"
                  data-testid={`update-entry-${u.version}`}
                >
                  {/* Timeline dot */}
                  <span
                    aria-hidden
                    className="hidden sm:flex absolute left-0 top-5 w-6 h-6 rounded-full bg-white border-2 border-[#C5A059] items-center justify-center shadow-sm"
                  >
                    <span className="w-2 h-2 rounded-full bg-[#C5A059]" />
                  </span>

                  {/* Card */}
                  <article className="bg-white border border-[#E5E5E0] rounded-2xl p-6 sm:p-8 shadow-[0_1px_0_rgba(0,0,0,0.02)] hover:border-[#C5A059]/40 transition-colors">
                    <header className="flex flex-wrap items-center gap-3 mb-5">
                      <span
                        className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#1A1A1A]"
                        data-testid={`update-version-${u.version}`}
                      >
                        <Rocket className="w-4 h-4 text-[#C5A059]" />
                        Version {u.version}
                      </span>
                      <span className="text-[#D4D4D4]">·</span>
                      <time className="text-sm text-[#737373]" data-testid={`update-date-${u.version}`}>
                        {u.date}
                      </time>
                      {u.tag && (
                        <span
                          className={`ml-auto text-[10px] tracking-[0.15em] uppercase font-semibold px-2.5 py-1 rounded-full border ${tagClass}`}
                        >
                          {u.tag}
                        </span>
                      )}
                    </header>

                    {u.title && (
                      <h2 className="font-serif-display text-2xl text-[#1A1A1A] mb-4">
                        {u.title}
                      </h2>
                    )}

                    {u.summary && (
                      <p
                        className="text-[15px] text-[#525252] leading-relaxed mb-5"
                        data-testid={`update-summary-${u.version}`}
                      >
                        {u.summary}
                      </p>
                    )}

                    {u.sections && u.sections.length > 0 ? (
                      <div className="space-y-5">
                        {u.sections.map((s, si) => (
                          <div key={si} data-testid={`update-section-${u.version}-${s.kind}`}>
                            <h3 className="text-[11px] tracking-[0.18em] uppercase text-[#737373] font-medium mb-2.5">
                              {s.title}
                            </h3>
                            <ul className="space-y-2.5">
                              {s.items.map((it, ii) => (
                                <li
                                  key={ii}
                                  className="flex items-start gap-3 text-[15px] text-[#404040] leading-relaxed"
                                >
                                  <CheckCircle2 className="w-4 h-4 text-[#C5A059] mt-0.5 flex-shrink-0" />
                                  <span>{it}</span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <ul className="space-y-2.5">
                        {u.highlights.map((h, i) => (
                          <li
                            key={i}
                            className="flex items-start gap-3 text-[15px] text-[#404040] leading-relaxed"
                          >
                            <CheckCircle2 className="w-4 h-4 text-[#C5A059] mt-0.5 flex-shrink-0" />
                            <span>{h}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </article>
                </li>
              );
            })}
          </ol>
        </div>

        {/* Footer note */}
        <div className="mt-14 pt-8 border-t border-[#E5E5E0] text-center">
          <p className="text-sm text-[#737373]">
            Got feedback or a feature request?{" "}
            <a
              href="mailto:supporto@aitricoprotocol.com"
              className="text-[#C5A059] hover:text-[#8A6B2E] font-medium transition-colors"
              data-testid="updates-contact-link"
            >
              supporto@aitricoprotocol.com
            </a>
          </p>
        </div>
      </div>
    </Layout>
  );
}
